import React from 'react';

import { EntityEdit } from '../index';

const Edit = props => {
  return <EntityEdit {...props} />;
};

export default Edit;
